(function() {
    /**
     * Find the toggle button and stock list, 
     * then wire up the click handler.
     */
    function initStockToggle() {
        var toggleBtn = document.getElementById('toggle-stock-levels');
        var stockList = document.querySelector('.stock-levels__centres');
        var storeDetails = document.querySelector('.stock-levels__label');
        var storeCollect = document.querySelector('.stock-levels__content--collect');

        if ( ! toggleBtn || ! stockList || ! storeDetails || ! storeCollect ) {
            return;
        }

        toggleBtn.addEventListener('click', function() {
            stockList.classList.toggle('visible');
            toggleBtn.classList.toggle('visible');
            storeDetails.classList.toggle('visible');
            storeCollect.classList.toggle('visible');
        });
    }

    // Run on DOM ready
    document.addEventListener('DOMContentLoaded', initStockToggle);
})();